import { FuelIndexingEnum } from './enums/fuel-indexing.enum';

export class FuelIndexing {
  public id!: number;
  public transporterId!: number;
  public customerId?: number;
  public share?: number;
  public reference?: number;
  public fixedRate?: number;
  public forcedPositive: boolean = false;
  public indexValue!: IndexFuelIndexing;
  public offerId?: number;
  public creationDate!: Date;
  public updatedDate!: Date;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.indexValue = LIST_FUEL_INDEXING[data?.indexValue ? data.indexValue : FuelIndexingEnum.PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE];
  }

  serialize(): any {
    return {
      id: this.id,
      transporterId: this.transporterId,
      share: this.share,
      reference: this.reference,
      fixedRate: this.fixedRate,
      forcedPositive: this.forcedPositive,
      indexValue: this.indexValue.code,
      offerId: this.offerId,
      customerId: this.customerId,
      creationDate: this.creationDate,
      updatedDate: this.updatedDate,
    };
  }
}

export class IndexFuelIndexing {
  public code!: string;
  public translationKey!: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_FUEL_INDEXING: { [key: string]: IndexFuelIndexing } = {
  PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE: new IndexFuelIndexing({
    code: FuelIndexingEnum.PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE,
    translationKey: 'LIST_FUEL_INDEXING.PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE',
  }),
  INDICE_CNR_GAZOLE_PROFESSIONNEL: new IndexFuelIndexing({
    code: FuelIndexingEnum.INDICE_CNR_GAZOLE_PROFESSIONNEL,
    translationKey: 'LIST_FUEL_INDEXING.INDICE_CNR_GAZOLE_PROFESSIONNEL',
  }),
  INDICE_CNR_GAZOLE_HORS_TVA: new IndexFuelIndexing({
    code: FuelIndexingEnum.INDICE_CNR_GAZOLE_HORS_TVA,
    translationKey: 'LIST_FUEL_INDEXING.INDICE_CNR_GAZOLE_HORS_TVA',
  }),
  PRIX_GAZOLE_POMPE_MOYENNE_MENSUELLE: new IndexFuelIndexing({
    code: FuelIndexingEnum.PRIX_GAZOLE_POMPE_MOYENNE_MENSUELLE,
    translationKey: 'LIST_FUEL_INDEXING.PRIX_GAZOLE_POMPE_MOYENNE_MENSUELLE',
  }),
  PRIX_CNR_GAZOLE_CUVE_FIN_DE_MOIS: new IndexFuelIndexing({
    code: FuelIndexingEnum.PRIX_CNR_GAZOLE_CUVE_FIN_DE_MOIS,
    translationKey: 'LIST_FUEL_INDEXING.PRIX_CNR_GAZOLE_CUVE_FIN_DE_MOIS',
  }),
};

export const enum TYPE_FUEL_INDEXING_STRATEGY {
  OFFERS = 'OFFERS',
  CUSTOMERS = 'CUSTOMERS',
}
